// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M12.6 12L8.7 8.1Q8.42 7.82 8.42 7.4T8.7 6.7 9.4 6.42 10.1 6.7L14.7 11.3Q14.85 11.45 14.91 11.63T14.97 12.01 14.91 12.39 14.7 12.72L10.1 17.32Q9.82 17.6 9.4 17.6T8.7 17.32 8.42 16.62 8.7 15.92Z"/>';

/** Chevron Right (arrows). */
const icon: IconData = {
  id: "chevron-right",
  name: "Chevron Right",
  category: "arrows",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: '<path d="M12.6 12L8 7.4 9.4 6 15.4 12 9.4 18 8 16.6Z"/>' },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M12.6 12L8.7 8.1Q8.42 7.82 8.42 7.4T8.7 6.7 9.4 6.42 10.1 6.7L14.7 11.3Q14.85 11.45 14.91 11.63T14.97 12.01 14.91 12.39 14.7 12.72L10.1 17.32Q9.82 17.6 9.4 17.6T8.7 17.32 8.42 16.62 8.7 15.92Z"/></g><path d="M12.6 12L8.7 8.1Q8.42 7.82 8.42 7.4T8.7 6.7 9.4 6.42 10.1 6.7L14.7 11.3Q14.85 11.45 14.91 11.63T14.97 12.01 14.91 12.39 14.7 12.72L10.1 17.32Q9.82 17.6 9.4 17.6T8.7 17.32 8.42 16.62 8.7 15.92Z"/>',
    },
  },
  animation: () => import("../animations/chevron-right.js"),
};

export default icon;
